"use strict";
// intermediate-tape.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
});
exports.nodeType = 'file_intermediateTape';
exports.artifactType = 'intermediateTape';
//# sourceMappingURL=types.js.map